// The "Who talks about them" tab of a public figure's page (15 October 2026).
export default {
  pct: '{n}%',
  autres: 'Others',
  groupes: 'Groups',
  quand: { aujourdhui: 'today', le: 'on {jour}' },
  graphe: {
    titre: 'Who drives the conversation, day by day',
    legende: 'each group’s share of what is said, over {n} day | each group’s share of what is said, over {n} days',
    aujourdhui: 'today',
    aria: 'Each group’s share of the conversation, over {n} day; {quand}: {parts}. | Each group’s share of the conversation, over {n} days; {quand}: {parts}.',
  },
  carte: {
    ecart: '{n} pts over 7 days',
    courbe: 'their share, over {n} day | their share, over {n} days',
    courbeAria: 'Their share of the conversation over {n} day, {part} {quand} | Their share of the conversation over {n} days, {part} {quand}',
  },
  bascule: {
    camp: 'Switches sides: {avant} the week before, {apres} {quand}',
    poidsPlus: 'Suddenly weighs more in the conversation',
    poidsMoins: 'Suddenly weighs less in the conversation',
  },
  sens: {
    regard: 'their view',
    maintenant: '{n} {quand}',
    avant: '{n} the week before (grey mark)',
  },
  electeurs: {
    titre: 'And their voters?',
    texte: 'Those who talk about them are not those who vote. When this public figure runs in an election you follow, their voters appear here, and you can talk to them.',
    // When they do (16 October 2026).
    cherche: 'Checking whether this public figure runs in an election you follow…',
    candidat: 'Their voters: {election}',
    distincts: 'Those who talk about them are not those who vote: here is where their voters come from at the latest wave, segment by segment.',
    projectionPct: 'Projection {n} ({bas} ~ {haut})',
    projectionSieges: 'Projection {n} seats ({bas} ~ {haut})',
    voirElection: 'See the election',
  },
  // Their full profile, in the side panel (16 October 2026).
  fiche: {
    ouvrir: 'See {nom}’s profile',
    titre: '{nom}, “{groupe}”',
  },
  chargement: 'Loading who talks about them…',
  vide: 'The groups of those who talk about them take shape after a few days of listening',
  // Talking to someone from the group (15 October 2026).
  parler: {
    bouton: 'Talk to {nom}',
    origine: '“{groupe}”, among those who talk about {qui}',
    q1: 'What do you think of {qui} right now?',
    q2: 'What would change your mind about {qui}?',
    q3: 'Where do you talk about it, and with whom?',
    bientot: 'Someone from this group to talk to takes shape at the next listening.',
  },
}
